import React from "react";
import { compose } from "recompose";
import { Table } from "reactstrap";
import { AddNewButton, EditDeleteButtons, Page, withTable } from "components/common";
import { Trans } from "react-i18next";
import BackButton from '../../PayrollHrNew/BackButton'

export const TaxRulesList = ({
  TableContainer,
  match,
  data,
  Pagination,
  onDeleteItem,
  PayrollTableDataFetch,
  PayrollBulkDeleteButton,
  TableSearch
}) => (
  <Page title="" className="inv-table">
    <BackButton/>
    <h4 style={{marginTop:"15px",marginBottom:"20px"}}><Trans>Tax Rules</Trans></h4>
    <TableSearch />
    <PayrollBulkDeleteButton className="d-none" />
    <AddNewButton resource="Tax Rule" match={match} className="mb-2 mt-3" />
    <TableContainer>
      <Table className="no-wrap v-middle text-center" responsive>
        <thead>
          <tr>
            <th sortBy="description" className="text-nowrap">
              <Trans>Description</Trans>
            </th>
            <th sortBy="amount" className="text-nowrap">
              <Trans>Tax Rate</Trans>
            </th>
            <th>
              <Trans>Apply To</Trans>
            </th>
            <th><Trans>Actions</Trans></th>
          </tr>
        </thead>
        <tbody>
        {data.results.map((i) => (
          <tr key={i.id}>
            <td>{i.description}</td>
            <td>{i.tax_rule}</td>
            <td>{i.apply_to_employees.map((item, idx) => `${item.value === true ? item.name : ''} ${
              idx === i.apply_to_employees.length - 1 ? '' : item.value === true ? '/ ' : ''}`)}</td>
            <td className="text-end text-nowrap">
              <EditDeleteButtons
                url={match.url}
                id={i.id}
                onDelete={onDeleteItem}
              />
            </td>
          </tr>
        ))}
        </tbody>
      </Table>
    </TableContainer>
    <PayrollTableDataFetch />
    <div className="clearfix">
      <div className="float-right"><Pagination /></div>
    </div>
  </Page>
);

const enhance = compose(withTable({ limit: 100, url: "tax_rules" }));

export default enhance(TaxRulesList);
